import { render, staticRenderFns } from "./GridSectionSingle.vue?vue&type=template&id=e2255bec&scoped=true&"
import script from "./GridSectionSingle.vue?vue&type=script&lang=js&"
export * from "./GridSectionSingle.vue?vue&type=script&lang=js&"
import style0 from "./GridSectionSingle.vue?vue&type=style&index=0&id=e2255bec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2255bec",
  null
  
)

export default component.exports